import OXAddPackageBanner from './ox-add-package-banner'

export default OXAddPackageBanner
